module.exports = __webpack_public_path__ + "prod/1.42.2/img/yycj_three.308f889b.png";